module.exports = __webpack_public_path__ + "static/media/house_half.abb708cf.png";